<template>
  <div class="footer">
    <div class="footer-box">
      <div class="logo-box">
        <div class="logo-name">
          <img src="../assets/logo.png" class="logo-1" />
          <p>PT DANISWARA TEKNOLOGI INDONESIA</p>
        </div>
      </div>
      <div class="connect">
        <p><img src="../assets/address.png" alt="" /> Graha Mampang Lt.3 suite 305, Jl. Mampang Prpt. Raya No.KAV.100,
          Desa/Kelurahan Duren Tiga, Kec. Pancoran, Kota Adm. Jakarta Selatan,
          Provinsi DKI Jakarta,
          Kode Pos: 12760</p>
      </div>
      <div class="connect">
        <p><img src="../assets/tel.png" alt="" /> 83870909182</p>
        <p><img src="../assets/email.png" alt="" /> cs@ptdaniswarateknologi.com</p>
      </div>
    </div>

    <div class="copyright">
      © 2024 PT DANISWARA TEKNOLOGI INDONESIA All rights reserved.

    </div>
  </div>
</template>
<style lang="less" scoped>
  .footer {
    .footer-box {
      height: 176px;
      background: #fff;
      padding: 50px 360px;
      padding-bottom: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .logo-box {
        width: 500px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;

        .logo-name {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          .logo-1 {
            width: 38px;
            height: 38px;
            margin-right: 14px;
          }

          p {
            font-family: DINCondensed, DINCondensed;
            font-weight: bold;
            font-size: 23px;
            color: #25274D;
          }
        }

        .text {
          font-family: Roboto, Roboto;
          font-weight: 400;
          font-size: 20px;
          color: rgba(51, 51, 51, 0.8);
          margin-top: 20px;
        }
      }

      .connect {
        font-family: Roboto, Roboto;
        font-weight: bold;
        font-size: 18px;
        color: #333333;


        p {
          max-width: 400px;
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          img {
            width: 23px;
            vertical-align: middle;
            margin-right: 10px;
          }
        }
      }
    }

    .copyright {
      margin: 0 360px;
      height: 76px;
      background: #fff;
      border-top: 1px solid #D7D8DE;
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      line-height: 76px;
      text-align: center;
    }
  }
</style>
<script>
  export default {
    data() {
      return {};
    },
    methods: {
      send() {
        alert("send success");
      },
      selectMenu(value) {
        this.index = value;
        if (value == this.step) {
          return;
        }
        switch (value) {
          case 1:
            this.$router.push({ path: "/" });
            break;
          case 2:
            this.$router.push({ path: "about" });
            break;
          case 3:
            this.$router.push({ path: "services" });
            break;
          case 4:
            this.$router.push({ path: "offers" });
            break;
          case 5:
            this.$router.push({ path: "contact" });
            break;
          // case 5: this.$router.push({ path: "cooperate" }); break;
          default:
            this.$router.push({ path: "/" });
            break;
        }
      },
    },
  };
</script>